import { CurrencyType } from "src/features/products/productsSlice";
import currencies from "src/shared/assets/currency";
import { store } from "../store";

export default function getCurrencyFromJson() {
  const targetCurrency: CurrencyType =
    globalThis?.GLOBALS?.PRICE_FORMAT_OPTIONS?.currency?.currencyCode ??
    globalThis?.GLOBALS?.PRICE_FORMAT_OPTIONS?.currency ??
    store.getState().products.currencyType;
  const foundCurrency = targetCurrency ? currencies[targetCurrency] : null;

  const {
    useCurrencyAfterPrice: _useCurrencyAfterPrice,
    useCurrencySymbol: _useCurrencySymbol,
  } = globalThis?.GLOBALS?.PRICE_FORMAT_OPTIONS?.currency ?? {};

  return {
    currencyCode: foundCurrency?.symbol ?? "TL",
    useCurrencyAfterPrice: _useCurrencyAfterPrice ?? true, // ? Todo ?
    useCurrencySymbol: _useCurrencySymbol ?? true, // ? Todo ?
  };
}
